import React from 'react';
import moize from 'moize';
import moment from 'moment';
import ContentOverTimeBars from 'components/Graphs/ContentOverTimeBars';
import { DATE_FORMAT } from 'constants/graphConstants.js';
import { TileContentContainer } from './styled.js';

class ContentTimeSeriesTile extends React.Component {
  constructor() {
    super();
    this.memoData = moize.deep(entityKeys => this.generateDataMap(entityKeys));
  }

  generateDataMap(entityKeys = []) {
    /* Reshape data object to understand comparisons for each data piece */
    const { content } = this.props;
    const dataMap = {};

    entityKeys.forEach((entity) => {
      const overTimeData = content[entity].data && content[entity].data.num_content_over_time ? content[entity].data.num_content_over_time : [];
      overTimeData.forEach(({ time, value, date, num_content }) => {
        // We need to check that the payloads key is formatted in milliseconds such as '1533081600'
        const dateIsFormatted = date && moment(date, DATE_FORMAT).format(DATE_FORMAT) === date;
        let timeKey;

        if (dateIsFormatted) {
          timeKey = date;
        } else if (date && !dateIsFormatted) {
          timeKey = moment(date * 1000).format(DATE_FORMAT);
        } else {
          timeKey = time;
        }

        dataMap[timeKey] = dataMap[timeKey] || {}; // find or initialize object;
        dataMap[timeKey][entity] = num_content || value; // set key as entity id
      });
    });

    /** Bundle everything back up into a data array. e.g.:
       data: [
        {
          time: "2019-03-01",
          7b47ccdf-f8b4-4a5b-8504-22675ea9e1f1: 19974,
          9f50xfwe-f8b4-8fs8-9999-22675ea39f9e: 6938,
        },
        {
          time: "2019-03-01",
          7b47ccdf-f8b4-4a5b-8504-22675ea9e1f1: 21314,
          9f50xfwe-f8b4-8fs8-9999-22675ea39f9e: 974,
        }]
    */
    return Object.keys(dataMap).map(key => ({ time: key, ...dataMap[key] }));
  }

  render() {
    const { entities } = this.props;
    const entityKeys = entities.map(({ public_id }) => public_id) || [];
    const data = this.memoData(entityKeys);

    return (
      <TileContentContainer>
        <ContentOverTimeBars data={data} entities={entities} />
      </TileContentContainer>
    );
  }
}

export default ContentTimeSeriesTile;
